/*eslint-disable*/
import React from "react";

export default function Navbar(props) {
  const [navbarOpen, setNavbarOpen] = React.useState(false);
  return (
    <>
      <nav className="top-0 fixed bg-white z-50 w-full flex flex-wrap items-center justify-between px-2 py-3 navbar-expand-lg shadow">
        <div className="container px-4 mx-auto flex flex-wrap items-center justify-between">
          <div className="w-full relative flex justify-between lg:w-auto lg:static lg:block lg:justify-start">
            
            <a
                      onClick={() => {
                        setNavbarOpen(false)
                        const el = document.getElementById("top-section");
                        if (el) {
                          const yOffset = -80; // adjust this value to control top spacing
                          const y =
                            el.getBoundingClientRect().top + window.pageYOffset + yOffset;

                          window.scrollTo({ top: y, behavior: "smooth" });
                        }
                      }}
                      className="text-warmGray-800 text-sm font-bold leading-relaxed inline-block mr-4 py-2 whitespace-nowrap uppercase"
                      style={{cursor: "pointer"}}
                    >
                      LSFM 2025/26
                    </a>
              <div className="flex flex-row justify-end gap-4">   
             <button
                      onClick={() => {
                        const el = document.getElementById("purchase-section");
                        if (el) {
                          const yOffset = -80; // adjust this value to control top spacing
                          const y =
                            el.getBoundingClientRect().top + window.pageYOffset + yOffset;

                          window.scrollTo({ top: y, behavior: "smooth" });
                        }
                      }}
                      className={" lg:hidden mx-2  bg-lsfm-primary-600 text-white font-bold uppercase text-sm px-6 py-3 rounded shadow hover:shadow-lg transition-all duration-150 ease-in-out"}
                    >
                      Biļetes
                    </button>        
            <button
              className="cursor-pointer text-xl leading-none px-3 py-1 border border-solid border-transparent rounded bg-transparent block lg:hidden outline-none focus:outline-none"
              type="button"
              onClick={() => setNavbarOpen(!navbarOpen)}
            >
              <i className="text-warmGray fas fa-bars"></i>
            </button>
                </div>   
          </div>
          <div
            className={
              "lg:flex flex-grow items-center bg-white lg:bg-opacity-0 lg:shadow-none" +
              (navbarOpen ? " block rounded shadow-lg" : " hidden")
            }
            id="example-navbar-warning"
          >
            <ul className="flex flex-col lg:flex-row list-none mr-auto">

              
              
            </ul>
            <ul className="flex flex-col lg:flex-row list-none lg:ml-auto">
               
               <li className="flex items-center">
                 <a
                      onClick={() => {
                        setNavbarOpen(!navbarOpen)
                        const el = document.getElementById("why-section");
                        if (el) {
                          const yOffset = -80; // adjust this value to control top spacing
                          const y =
                            el.getBoundingClientRect().top + window.pageYOffset + yOffset;

                          window.scrollTo({ top: y, behavior: "smooth" });
                        }
                      }}
                      className="lg:text-warmGray-800 lg:hover:text-warmGray-800 text-warmGray-700 w-full lg:w-auto px-3 py-4 lg:py-2 flex items-center text-xs uppercase font-bold "
                      style={{cursor: "pointer"}}
                    >
                      Kāpēc piedalīties?
                    </a>
              </li>
              <li className="flex items-center">
                 <a
                      onClick={() => {
                        setNavbarOpen(!navbarOpen)
                        const el = document.getElementById("sponsor-section");
                        if (el) {
                          const yOffset = -80; // adjust this value to control top spacing
                          const y =
                            el.getBoundingClientRect().top + window.pageYOffset + yOffset;

                          window.scrollTo({ top: y, behavior: "smooth" });
                        }
                      }}
                      className="lg:text-warmGray-800 lg:hover:text-warmGray-800 text-warmGray-700 w-full lg:w-auto px-3 py-4 lg:py-2 flex items-center text-xs uppercase font-bold "
                      style={{cursor: "pointer"}}
                    >
                      Sponsori
                    </a>
              </li>

              <li className="flex items-center">
                 <a
                      onClick={() => {
                        setNavbarOpen(!navbarOpen)
                        const el = document.getElementById("participants-section");
                        if (el) {
                          const yOffset = -80; // adjust this value to control top spacing
                          const y =
                            el.getBoundingClientRect().top + window.pageYOffset + yOffset;

                          window.scrollTo({ top: y, behavior: "smooth" });
                        }
                      }}
                      className="lg:text-warmGray-800 lg:hover:text-warmGray-800 text-warmGray-700 w-full lg:w-auto px-3 py-4 lg:py-2 flex items-center text-xs uppercase font-bold "
                      style={{cursor: "pointer"}}
                    >
                      Lektori
                    </a>
              </li>

              
              <li className="flex items-center">
                 <a
                      onClick={() => {
                        setNavbarOpen(!navbarOpen)
                        const el = document.getElementById("programme-section");
                        if (el) {
                          const yOffset = -80; // adjust this value to control top spacing
                          const y =
                            el.getBoundingClientRect().top + window.pageYOffset + yOffset;

                          window.scrollTo({ top: y, behavior: "smooth" });
                        }
                      }}
                      className="lg:text-warmGray-800 lg:hover:text-warmGray-800 text-warmGray-700 w-full lg:w-auto px-3 py-4 lg:py-2 flex items-center text-xs uppercase font-bold "
                      style={{cursor: "pointer"}}
                    >
                      Programma
                    </a>
              </li>

              <li className="flex items-center">
                 <a
                      onClick={() => {
                        setNavbarOpen(!navbarOpen)
                        const el = document.getElementById("about-section");
                        if (el) {
                          const yOffset = -80; // adjust this value to control top spacing
                          const y =
                            el.getBoundingClientRect().top + window.pageYOffset + yOffset;

                          window.scrollTo({ top: y, behavior: "smooth" });
                        }
                      }}
                      className="lg:text-warmGray-800 lg:hover:text-warmGray-800 text-warmGray-700 w-full lg:w-auto px-3 py-4 lg:py-2 flex items-center text-xs uppercase font-bold "
                      style={{cursor: "pointer"}}
                    >
                      Par mums
                    </a>
              </li>
              
              
                <button
                      onClick={() => {
                        setNavbarOpen(!navbarOpen)
                        const el = document.getElementById("purchase-section");
                        if (el) {
                          const yOffset = -80; // adjust this value to control top spacing
                          const y =
                            el.getBoundingClientRect().top + window.pageYOffset + yOffset;

                          window.scrollTo({ top: y, behavior: "smooth" });
                        }
                      }}
                      className="mx-4 hidden lg:block bg-lsfm-primary-600 text-white font-bold uppercase text-sm px-6 py-3 rounded shadow hover:shadow-lg transition-all duration-150 ease-in-out"
                    >
                      Biļetes
                    </button>
              <li className="flex items-center "> 
              </li>

              <li className="flex items-center">
                <a
                  className="lg:text-warmGray lg:hover:text-warmGray-200 text-warmGray-700 px-3 py-4 lg:py-2 flex items-center text-xs uppercase font-bold"
                  href="https://instagram.com/latviansfm"
                  target="_blank"
                  rel="noreferrer"
                >
                  <i className="lg:text-warmGray-800 text-warmGray-800 fab fa-instagram text-lg leading-lg " />
                  <span className="lg:hidden inline-block ml-2">LSFM on Instagram</span>
                </a>
              </li>
              
              <li className="flex items-center">
                <a
                  className="lg:text-warmGray-800 lg:hover:text-warmGray-800 text-warmGray-700 px-3 py-4 lg:py-2 flex items-center text-xs uppercase font-bold"
                  href="https://www.facebook.com/profile.php?id=61555953753126#"
                  target="_blank"
                  rel="noreferrer"
                >
                  <i className="lg:text-warmGray-800 text-warmGray-800 fab fa-facebook text-lg leading-lg " />
                  <span className="lg:hidden inline-block ml-2">LSFM on Facebook</span>
                </a>
              </li>

              
         

            
            </ul>
          </div>
        </div>
      </nav>
    </>
  );
}
